import React, { FC } from "react";
import { Card, Col, Row } from "antd";
import { useParams } from "react-router-dom";

import useHttpGet from "../../../hooks/useHttpGet";
import { IResultResponse } from "../../../models/response/result.model";
import { APIRoutes } from "../../../http";
import { IMagicPage } from "../../../models/magic-page";

const Pages: FC = () => {
  const { id } = useParams();

  const { fetchedData, loading } = useHttpGet<IResultResponse<IMagicPage>>(
    `${APIRoutes.MAGIC_PAGES}/${id}`,
    {
      dependencies: [id],
      defaultValue: { result: {} as IMagicPage },
    }
  );

  return (
    <Row justify="center" align="top">
      <Col xs={24} sm={24} md={20}>
        <Card
          className="mb-1 custom-card-1"
          title={
            <div className="d-flex align-items-center">
              <span className="fs-36">{fetchedData.result?.title}</span>
            </div>
          }
          loading={loading}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: fetchedData.result?.content,
            }}
            className="pl-1 pt-0_5"
          />
        </Card>
      </Col>
    </Row>
  );
};

export default Pages;
